import {useContext} from 'react';
import {AuthContext} from '../../context/AuthContext.tsx';
import {isLegacySubscriber} from '../../util/pricingModel.ts';
import {NewJobDemand} from './NewJobDemand.tsx';
import {NewJobDemandPricing} from './NewJobDemandPricing.tsx';
import {Loader} from '../../components/Loader.tsx';

export const NewJobDemandRouter = () => {
    const {user, loadingUserData} = useContext(AuthContext);

    if (loadingUserData || !user) {
        return <Loader/>;
    }

    // Legacy users see the existing flow
    if (isLegacySubscriber(user)) {
        return <NewJobDemand/>;
    }

    // New pricing users see the per-job pricing flow
    return <NewJobDemandPricing/>;
};
